// extracted by mini-css-extract-plugin
var _1 = "ChooseMany_checked__tbmdN";
var _2 = "ChooseMany_chooseManyContainer__zPNS7";
var _3 = "ChooseMany_disabled__C5bGy";
var _4 = "ChooseMany_explanation__zDXeW";
var _5 = "ChooseMany_liEnabledOtherChoice__KwO+H";
var _6 = "ChooseMany_liExplanation__VUI5Q";
var _7 = "768px";
var _8 = "ChooseMany_otherChoice__teyR9";
var _9 = "ChooseMany_otherChoiceExplanation__Npkd6";
var _a = "\"../../../shared.module.css\"";
var _b = "ChooseMany_textareaExplanationStyles__OyBk9";
export { _1 as "checked", _2 as "chooseManyContainer", _3 as "disabled", _4 as "explanation", _5 as "liEnabledOtherChoice", _6 as "liExplanation", _7 as "md", _8 as "otherChoice", _9 as "otherChoiceExplanation", _a as "shared", _b as "textareaExplanationStyles" }
